export class UploadFileInfo {
    id: number;
    lastUpdateTime?: Date = new Date();
    numberOfEntries: number;
    numberOfErrors: number;
    uploadFileStatus: string;
    name: string;
    email: string;
    role: string;
    uploadFileType: UploadFileType;
    errorFilePath?: string;
    uploadedFilePath?: string;
}

export enum UploadFileType {
    Customers,
    Poles,
    Buildings,
    Dts,
    Meters,
    Surveys,
    DtsCrud,
    BulkReassign,
    BulkUserCreation,
    MetersStock,
    Regularization,
    BillingAccount,
    CustomersConvert,
    CustomersUpdate,
    FlagMetersForMeterValidation,
    ReassignDts,
    Substations,
    CimPowerTransformer,
    ACLine,
    NewConnection,
    MeterConfiguration,
    BulkVendorAssignment,
    BulkConfirmPayment,
    UploadCustomerUpdate,
    UpdateFeederBands,
    InstallationBulkAssignment,
    BulkVendorReassignment,
    BulkOrgAssignment,
    BulkFeederReassignment,
    BulkRoleReassignment,
    AuthorizeMetering = 32,
    BulkDtVendorAssignment = 33,
    BulkDtInstallerAssignment = 34,
    BulkDtVendorReassignment = 35
}